export default __webpack_public_path__ + "static/media/edit.ddc7db22.svg";